import { NukeIcon } from './NukeIcon';

/**
 * author: GreenTurtwig
 * id DB44684C-B1E7-4039-8BAA-C7C0BC4EB075
 * name nuke
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/nuke.svg
 * tags
 */
export const AtomicBombIcon = NukeIcon;
export default AtomicBombIcon